<template>
<w-sliding-popup
  popupClass="topologymap-perfinfo-popup"
  type="full"
  :title="title"
  @close="close"
  :visible="true"
  ref="slidingPopup">
    <div slot="content">
      <div class="page-container-content tabgroup">
        <w-tool-tabs v-model="activeTabName" @tab-click="tabClick">
          <el-tab-pane :label="tabs.performance.label" :name="tabs.performance.name">
            <w-topologymap-objtype-bar ref="topologymapObjtypebar" :active="tabs.performance.active"></w-topologymap-objtype-bar>
            <w-topologymap-performance-index ref="topologymapPerformanceIndex" :active="tabs.performance.active"></w-topologymap-performance-index>
          </el-tab-pane>
          <el-tab-pane :label="tabs.config.label" :name="tabs.config.name">
            <w-topologymap-objtype-bar :active="tabs.config.active"></w-topologymap-objtype-bar>
            <w-topologymap-config-index ref="topologymapConfigIndex" :active="tabs.config.active"></w-topologymap-config-index>
          </el-tab-pane>
        </w-tool-tabs>
      </div>
    </div>
</w-sliding-popup>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

import WTopologymapPerformanceIndex from '@/views/topologymap/components/perfoper/performance/TopologymapPerformanceIndex';
import WTopologymapConfigIndex from '@/views/topologymap/components/perfoper/config/TopologymapConfigIndex';
import WTopologymapObjtypeBar from '@/views/topologymap/components/perfoper/TopologymapObjtypeBar';

export default {
  name: 'WTopologymapPerfInfoPopup',
  components: {
    WTopologymapPerformanceIndex,
    WTopologymapConfigIndex,
    WTopologymapObjtypeBar,
  },
  data() {
    return {
      tabs: {
        performance: {
          name: 'performance',
          label: '성능 정보',
          active: true,
        },
        config: {
          name: 'config',
          label: '구성 정보',
          active: false,
        },
      },
      activeTabName: 'performance',
    };
  },
  computed: {
    title() {
      const breadCrumb = this.$store.getters.getBreadcrumb;
      const mapName = isEmpty(breadCrumb) ? '' : breadCrumb[breadCrumb.length - 1].mapName;
      return `[${mapName}] 성능/구성 정보`;
    },
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    open() {
      this.activeTabName = 'performance';
      this.tabs.performance.active = true;
      this.$refs.slidingPopup.visible = true;
    },
    close() {
      this.tabs.config.active = false;
      this.tabs.performance.active = false;
      this.$refs.topologymapObjtypebar.close();
      this.$refs.topologymapPerformanceIndex.close();
      this.$refs.slidingPopup.visible = false;
    },
    tabClick(clickedTab) {
      if (clickedTab.name === 'config') {
        this.tabs.config.active = true;
        this.tabs.performance.active = false;
      } else {
        this.tabs.config.active = false;
        this.tabs.performance.active = true;
      }
    },
  },
};
</script>

<style lang="scss">
.topologymap-perfinfo-popup {
  .el-tabs__content {
    padding-top: 25px;

    .el-tabs__header > .el-tabs__nav-wrap {
      padding-left: 0px;
    }
  }

  .el-tabs__header > .el-tabs__nav-wrap {
    padding-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/popup/TopologymapPerfInfoPopup.vue